import { InteractiveRoutePlanner } from "../InteractiveRoutePlanner";

export function RouteCard() {
	return (
		<div
			className="w-[750px] rounded-2xl shadow-lg overflow-hidden transition-all duration-300 hover:scale-105 relative bg-white"
			style={{
				border: "1px solid #e5e7eb",
			}}
		>
			{/* Number badge */}
			<div
				className="absolute top-4 left-4 w-8 h-8 rounded-full flex items-center justify-center text-white font-bold text-base shadow-md z-10"
				style={{
					background: "linear-gradient(135deg, #C084FC 0%, #A78BFA 100%)",
				}}
			>
				2
			</div>

			{/* Content */}
			<div className="pt-16 px-6 pb-4">
				<h3 className="text-2xl font-bold mb-2 text-gray-900">Build Your Route</h3>
				<p className="text-gray-500 text-sm leading-relaxed mb-4">
					Drag destinations to reorder, adjust nights, and add sleeping accommodations. Plan your perfect journey.
				</p>

				{/* Route Table */}
				<div className="w-full">
					<InteractiveRoutePlanner />
				</div>
			</div>
		</div>
	);
}
